import React, { useEffect } from 'react';
import AOS from 'aos';
import Redirect from '../../../../CommonComponents/Redirect/Redirect';

import { HeaderToystory } from './HeaderToystory';
import { BodyToystory } from './BodyToystory';
import { FooterToystory } from './FooterToystory';

import './BaseToystory.scss';

const ToystoryLP = () => {
  const baseImgUrl = 'https://static.lenskart.com/owndays/img/toystory';
  const now = new Date();
  const isPreProd = process.env.ENVIRONMENT === 'preprod';
  const releaseTime = new Date('2025-06-06T10:00:00+08:00');

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const fadeRightKeys = ['woody-1', 'buzz-1', 'jessie', 'lotso', 'bo-peep', 'slinky-dog'];

    const imgElements = document.querySelectorAll('.body-toystory__lineup__header__img');

    imgElements.forEach(imgElement => {
      const dataKey = imgElement.getAttribute('data-key');

      if (window.innerWidth <= 767) {
        imgElement.setAttribute('data-aos', 'fade-up');
      } else {
        imgElement.removeAttribute('data-aos');
        imgElement.setAttribute(
          'data-aos',
          fadeRightKeys.includes(dataKey) ? 'fade-right' : 'fade-left'
        );
      }
    });

    AOS.refresh();
  }, []);

  if (!isPreProd && now < releaseTime) {
    return <Redirect to="/" />;
  }

  return (
    <div className="base-toystory">
      <HeaderToystory baseImgUrl={baseImgUrl} />
      <BodyToystory baseImgUrl={baseImgUrl} />
      <FooterToystory baseImgUrl={baseImgUrl} />
    </div>
  );
};

export default ToystoryLP;
